export enum TimeClockNotificationsFrequency {
    NEVER = "Never",
    QUARTER_HOUR = "15 Minutes",
    HALF_HOUR = "30 Minutes",
    HOUR = "1 Hour"
}

export function timeClockNotificationsFrequencyToMinutes(frequency: TimeClockNotificationsFrequency) {
    switch (frequency) {
        case TimeClockNotificationsFrequency.QUARTER_HOUR:
            return 15
        case TimeClockNotificationsFrequency.HALF_HOUR:
            return 30
        case TimeClockNotificationsFrequency.HOUR:
            return 60
        case TimeClockNotificationsFrequency.NEVER:
        default:
            return Number.MAX_SAFE_INTEGER
    }
}